import { useTranslation } from 'react-i18next'

const useTourRefineSearch = () => {
  const { t } = useTranslation('tour')
  return [
    {
      selector: '.joyride-tourRefineSearch-inputHotel',
      content: (
        <div>
          <p className="text-primary font-bold">
            {t('tour.refineSearchTitle')}
          </p>
          <span>{t('tour.refineSearchDescription')}</span>
        </div>
      ),
    },
  ]
}

export default useTourRefineSearch
